const videoPlay = () => {

  const videos = document.querySelectorAll('.article-video');

  if (!videos) return false;

  videos.forEach(video => {
    video.addEventListener('click', initVideoPlay, false);
  });

  function initVideoPlay(el) {
    el = this;
    const overlay = el.querySelector('.video__overlay');

    if (!this.classList.contains('is-playing')) {

      overlay.parentNode.removeChild(overlay);
      el.classList.add('is-playing');
      el.querySelector('video').play();

    }

    if (this.classList.contains('is-playing')) {
      return false;
    }
  }

}

export default videoPlay;